export const HEIGHT_ROW_TABLE = 63;
/**
 *
 * @param {number} heightViewBody
 * @param {boolean} isHasSubJv
 * @param {boolean} isUserMainJV
 * @return {number} height of table
 */
export const calcHeightTable = (
  heightViewBody,
  isHasSubJv = false,
  isUserMainJV = true
) => {
  const heightHeader = isUserMainJV ? 184 : 140;
  const heightHeaderTable = 36;
  let heightTable = heightViewBody - heightHeader - heightHeaderTable;
  if (isHasSubJv) {
    const heightTitleTable = 62;
    //Limit display 10 rows when has table subJV
    heightTable = Math.min(
      heightTable - heightHeaderTable - heightTitleTable,
      10 * HEIGHT_ROW_TABLE
    );
    const mod = heightTable % HEIGHT_ROW_TABLE;
    heightTable = heightTable - mod;
  }
  return heightTable + 1;
};



// WEBPACK FOOTER //
// ./src/utilities/IchiPlusLinkageSettingUtil.js